import 'selectize/dist/css/selectize.css'
import 'trumbowyg/dist/ui/trumbowyg.min.css'
import 'jssocials/dist/jssocials.css'
import 'jssocials/dist/jssocials-theme-flat.css'

import 'jquery'
import 'selectize'
import 'trumbowyg'
import 'jssocials'

import 'scripts/main-jquery.js'
import 'style/main-jquery.scss'



// WEBPACK FOOTER //
// app/javascript/packs/application-jquery.js